import { render } from "./DynamicModal.vue?vue&type=template&id=035e7a0b&scoped=true"
import script from "./DynamicModal.vue?vue&type=script&lang=js"
export * from "./DynamicModal.vue?vue&type=script&lang=js"

import "./DynamicModal.vue?vue&type=style&index=0&id=035e7a0b&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-035e7a0b"]])

export default __exports__